<div>
  <div *ngFor="let item of blogaso">
    <img src="https://new.lideart.com.mx/img/ybc_blog/post/{{image}}">
    <div style="margin-left: 15px; margin-right: 15px;" class="conti" [innerHTML]="descripcion">

    </div>
  </div>
</div>